import {
  FavoriteFixturesQueryParams,
  FavoriteFixturesResponse,
  FixtureApiResponse,
  FixtureCountsResponse,
  FixtureQueryParams,
} from '@/types/sportsFixture';
import { apiSlice } from './apiSlice';

export type FixtureFavoriteStatus = 'FAVORITE' | 'UNFAVORITE';

export const eventsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query<FixtureApiResponse, FixtureQueryParams>({
      query: ({
        sportName,
        competitionId,
        search,
        inplay,
        matchTime,
        status = 'ACTIVE',
        sortBy,
        isParlay = false,
      } = {}) => {
        const params = new URLSearchParams();

        if (sportName) params.append('sport', sportName);
        if (competitionId) params.append('competitionId', String(competitionId));
        if (typeof inplay === 'boolean') params.append('inplay', String(inplay));
        if (search) params.append('search', search);
        if (matchTime) params.append('matchTime', matchTime);
        if (status) params.append('status', status);
        if (sortBy) params.append('sortBy', sortBy);
        if (isParlay) params.append('isParlay', String(isParlay));

        const queryString = params.toString();
        return {
          url: `/fixture/groupbyCompetition${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
      providesTags: ['Events'],
    }),

    getFavoriteFixtures: builder.query<
      FavoriteFixturesResponse,
      FavoriteFixturesQueryParams | void
    >({
      query: ({ page, limit } = {}) => {
        const params = new URLSearchParams();

        if (page) params.append('page', String(page));
        if (limit) params.append('limit', String(limit));

        const queryString = params.toString();

        return {
          url: `/fixture/favorite${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
          requiresAuth: true,
        };
      },
      providesTags: ['Events'],
    }),

    updateFixtureFavorite: builder.mutation<
      { success: boolean; message: string },
      { eventId: number; status?: FixtureFavoriteStatus }
    >({
      query: ({ eventId, status = 'FAVORITE' }) => ({
        url: `/fixture/favorite/${eventId}`,
        method: 'PUT',
        body: { status },
        requiresAuth: true,
      }),
      invalidatesTags: ['Events'],
    }),

    getFixtureCounts: builder.query<FixtureCountsResponse, { isParlay: boolean }>({
      query: (params) => ({
        url: '/fixture/counts',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useGetEventsQuery,
  useLazyGetEventsQuery,
  useGetFavoriteFixturesQuery,
  useGetFixtureCountsQuery,
  useUpdateFixtureFavoriteMutation,
} = eventsApi;
